import Section from "./Section";
import Ledgerhome from "../../../assets/Ledgerhome.png";
import Dockethome from "../../../assets/Dockethome.png";
import Bitehome from "../../../assets/Bitehome.png";

const SectionComponents = () => {
  return (
    <>
      <Section
        bgColor="#EEF6FF"
        title="Ledger"
        description="Experience the ultimate in cash management with our sleek, smart and user-friendly cash register."
        buttonColor="#5865F2"
        imgSrc={Ledgerhome}
        link="/ledger"
      />
      <Section
        bgColor="#FFF"
        title="Docket"
        description="Say goodbye to schedule chaos and hello to organization with our advanced timetable planner. Plan your classes with precision and never miss a class again."
        buttonColor="#7313B9"
        imgSrc={Dockethome}
        link="/docket"
      />
      <Section
        bgColor="#E4FFEF"
        title="Bite"
        description="Transform your canteen operations and effortlessly manage inventory, track sales and streamline services."
        buttonColor="#0C9D46"
        imgSrc={Bitehome}
        link="/bite"
      />
    </>
  );
};

export default SectionComponents;
